export const clubDropdownSchema = {
	title: 'Club Dropdown schema',
	description: 'create a Clubdropdown schema',
	version: 1,
	primaryKey: 'sfid',
	type: 'object',
	properties: {
		id: {
			type: 'number',
		},
		sfid: { type: 'string', primary: true, maxLength: 200 },
		name: { type: 'string' },
		clublocation: { type: 'string' },
		clubid: { type: 'string' },
		assigned_imr_c: { type: ['string', 'null'] },
		imr_code_c: { type: ['string', 'null'] },
		assigned_mdi_c: { type: ['string', 'null'] },
		mdi_code_c: { type: ['string', 'null'] },
	},
	required: ['id', 'name', 'sfid', 'clublocation', 'clubid'],
};
